import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth, updateLastLogin } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import './Login.css';
import { ModalCarga } from '../ModalCarga/ModalCarga';

export const Login = () => {
    const navigate = useNavigate();
    const { user, loading } = useAuth();
    const [error, setError] = useState(null);

    async function handleGoogleAuth() {
        const googleProvider = new GoogleAuthProvider();
        try {
            const res = await signInWithPopup(auth, googleProvider);
            const user = res.user;
            await updateLastLogin(user.uid);
        } catch (err) {
            console.error(err);
            setError('Ocurrió un error al iniciar sesión con Google.');
        }
    }

    useEffect(() => {
        if (!loading) {
            if (user) {
                if (user.processCompleted) {
                    navigate('/');
                } else {
                    navigate('/elige-usuario');
                }
            }
        }
    }, [user, loading, navigate]);

    if (loading) {
        return <ModalCarga/>;
    }

    return (
        <div className='login'>
            <div className='login-texto'>
                <h1>¡Registrate gratis!</h1>
                <p>
                    Olvídate de perder horas buscando en múltiples webs de segunda mano. 
                    Con nuestro sistema de <strong>alertas inteligentes</strong> solo tienes que decirnos qué buscas y nosotros rastreamos todas las páginas por ti. 
                </p>
                <ul>
                    <li>Crea tus <strong>alertas personalizadas</strong> con los productos que quieras (1 con el plan gratis).</li>
                    <li>Cada día nos encargamos de <strong>buscar en múltiples webs de segunda mano</strong>.</li>
                    <li>Recibe <strong>avisos inmediatos</strong> cuando encontremos lo que buscas.</li>
                </ul>
                <p className="seguridad">
                <strong>100 % seguro:</strong> eRastro no interactúa en tu cuenta de Vinted, Wallapop o eBay.  
                Nuestro sistema analiza solo información pública, no tendrás riesgo de baneo en tus cuentas.
                </p>
                <h2>¡Hazte Premium!</h2>
                <p>
                    ¿Quieres aún más? Explora nuestros <span onClick={() => navigate('/premium')} style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}> servicios premium</span> y desbloquea funcionalidades avanzadas:
                </p>
                <ul>
                    <li>Crea múltiples <strong>alertas inteligentes</strong>.</li>
                    <li>Disfruta de una experiencia <strong>sin anuncios</strong>.</li>
                    <li>Usa nuestra <strong>Inteligencia Artificial</strong> para encontrar las mejores gangas.</li>
                    <li>Rastrea <strong>bajadas de precio</strong> en tus productos favoritos.</li>
                </ul>

                <p>
                    <em>En eRastro, buscamos por ti. Disfruta encontrando justo lo que querías.</em>
                </p>
                <div className='botones-login'>
                    <button className='boton-login' onClick={handleGoogleAuth}>
                        Iniciar Sesión / Registrarse con Google
                    </button>
                </div>
                {error && <p className="error-message">{error}</p>}
            </div>

            <img className='img-login' src="/imgs/login.jpeg" alt="chica mirando ropa en un baul" />
        </div>
    );
};
